export const narratorAudiobooks = [
  {
    id: '1',
    title: 'The Silent Echo',
    writtenAuthor: 'Sarah J. Miller',
    series: 'Echo Series',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    runtime: '10h 15m',
    genre: 'Mystery',
    rating: 4.8,
    releaseDate: '2023-01-15',
    format: 'audio',
    description: 'A gripping mystery brought to life through voice.',
  },
  {
    id: '2',
    title: 'Broken Echoes',
    writtenAuthor: 'Sarah J. Miller',
    series: 'Echo Series',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    runtime: '11h 30m',
    genre: 'Mystery',
    rating: 4.9,
    releaseDate: '2023-06-20',
    format: 'audio',
    description:
      'The sequel to The Silent Echo, featuring intense character voices.',
  },
  {
    id: '3',
    title: 'Final Echo',
    writtenAuthor: 'Sarah J. Miller',
    series: 'Echo Series',
    seriesNumber: 3,
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '12h 45m',
    genre: 'Mystery',
    rating: 4.7,
    releaseDate: '2023-11-10',
    format: 'audio',
    description: 'The thrilling conclusion to the Echo trilogy.',
  },
  {
    id: '4',
    title: 'Heart of the Storm',
    writtenAuthor: 'Elena Richards',
    series: 'Elements Trilogy',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '14h 20m',
    genre: 'Fantasy',
    rating: 4.6,
    releaseDate: '2022-03-15',
    format: 'audio',
    description: 'Epic fantasy narration with a full cast of character voices.',
  },
  {
    id: '5',
    title: 'Soul of Fire',
    writtenAuthor: 'Elena Richards',
    series: 'Elements Trilogy',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    runtime: '15h 10m',
    genre: 'Fantasy',
    rating: 4.8,
    releaseDate: '2022-09-01',
    format: 'audio',
    description: 'The saga continues with more magical battles and romance.',
  },
  {
    id: '6',
    title: 'Breath of Earth',
    writtenAuthor: 'Elena Richards',
    series: 'Elements Trilogy',
    seriesNumber: 3,
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    runtime: '16h 05m',
    genre: 'Fantasy',
    rating: 4.9,
    releaseDate: '2023-02-28',
    format: 'audio',
    description: 'The dramatic finale to the Elements Trilogy.',
  },
  {
    id: '7',
    title: 'Midnight Shadows',
    writtenAuthor: 'James Morgan',
    series: null,
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '9h 15m',
    genre: 'Horror',
    rating: 4.5,
    releaseDate: '2021-10-31',
    format: 'audio',
    description: 'A standalone horror novel that will keep you up at night.',
  },
  {
    id: '8',
    title: 'The Lost City',
    writtenAuthor: 'Marcus Blackwood',
    series: null,
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '11h 50m',
    genre: 'Adventure',
    rating: 4.4,
    releaseDate: '2022-07-12',
    format: 'audio',
    description: 'An action-packed adventure narrated with high energy.',
  },
  {
    id: '9',
    title: 'Voices of the Void',
    writtenAuthor: 'Various',
    series: 'Anthology Vol. 1',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '8h 30m',
    genre: 'SciFi',
    rating: 4.3,
    releaseDate: '2023-05-05',
    format: 'audio',
    isSpecialProject: true,
    description:
      'A multi-narrator anthology project featuring sci-fi short stories.',
  },
  {
    id: '10',
    title: 'Whispers in the Dark',
    writtenAuthor: 'Various',
    series: 'Anthology Vol. 2',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '9h 00m',
    genre: 'Horror',
    rating: 4.5,
    releaseDate: '2023-10-13',
    format: 'audio',
    isSpecialProject: true,
    description: 'A special Halloween anthology collaboration.',
  },
  {
    id: '11',
    title: 'Love in Paris',
    writtenAuthor: 'Claire Dubois',
    series: null,
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    runtime: '7h 45m',
    genre: 'Romance',
    rating: 4.2,
    releaseDate: '2021-02-14',
    format: 'audio',
    description: 'A sweet contemporary romance set in the city of lights.',
  },
  {
    id: '12',
    title: 'The Last Starship',
    writtenAuthor: 'David Chen',
    series: null,
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1050&q=80',
    runtime: '13h 20m',
    genre: 'SciFi',
    rating: 4.7,
    releaseDate: '2022-12-01',
    format: 'audio',
    description: 'A space opera epic with distinct alien voices.',
  },
]
